module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-treatments-adults",
    attrs: {
      "id": "adults"
    }
  }, [_c('div', {
    staticClass: "custom-treatments-adults__wrapper"
  }, [_c('div', {
    staticClass: "custom-treatments-adults__shape",
    domProps: {
      "innerHTML": _vm._s(_vm.shape)
    }
  }), _c('div', {
    staticClass: "custom-treatments-adults__container"
  }, [_c('div', {
    staticClass: "custom-treatments-adults__left"
  }, [_c('h2', [_vm._v(_vm._s(_vm.props.title))])]), _c('div', {
    staticClass: "custom-treatments-adults__right"
  }, _vm._l((_vm.props.cards), function(card, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-treatments-adults__card"
    }, [_c('div', {
      staticClass: "custom-treatments-adults__card-left"
    }, [_c('div', {
      staticClass: "custom-treatments-adults__icon-outer"
    }, [_c('div', {
      staticClass: "custom-treatments-adults__icon-inner"
    }, [_c('Icon', {
      staticClass: "custom-treatments-adults__icon",
      class: 'custom-treatments-adults__icon--' + card.label,
      attrs: {
        "name": card.label
      }
    })], 1)])]), _c('div', {
      staticClass: "custom-treatments-adults__card-right"
    }, [_c('div', {
      staticClass: "custom-treatments-adults__card-title",
      domProps: {
        "innerHTML": _vm._s(card.title)
      }
    }), _c('div', {
      staticClass: "custom-treatments-adults__card-text",
      domProps: {
        "innerHTML": _vm._s(card.text)
      }
    })])])
  }), 0)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b91f933","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-treatments-adults/custom-treatments-adults.pug
// module id = 718
// module chunks = 1